import { buildGlobalReferenceContext } from '../../../context/buildGlobalReferenceContext.mjs';

const [AvatarContextProvider, useAvatarContext] = buildGlobalReferenceContext("Avatar");

export { AvatarContextProvider, useAvatarContext };
//# sourceMappingURL=context.mjs.map
